module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/commons/templates/PayslipCard.ejs -->\n<div class="panel panel-default panel-payslip-card">\n    <div class="panel-heading">\n        '+
((__t=( payslip.getPeriodFormatted() ))==null?'':_.escape(__t))+
'\n    </div>\n    <div class="panel-body">\n        <div class="income">\n            RM '+
((__t=( payslip.get('netPay').formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n        </div>\n        <div>Net Income</div>\n    </div>\n    <ul class="list-group">\n        <li class="list-group-item">\n            <div class="row">\n                <div class="col-xs-4 col-sm-4">\n                    <div class="tax-label">PCB</div>\n                    <div class="tax-amount">\n                        '+
((__t=( (payslip.get('mtd') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                    </div>\n                </div>\n                <div class="col-xs-4 col-sm-4">\n                    <div class="tax-label">EPF</div>\n                    <div class="tax-amount">\n                        '+
((__t=( (payslip.get('employeeEpf') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                    </div>\n                </div>\n                <div class="col-xs-4 col-sm-4">\n                    <div class="tax-label">SOCSO</div>\n                    <div class="tax-amount">\n                        '+
((__t=( (payslip.get('employeeSocso') || 0).formatWithoutRounding() ))==null?'':_.escape(__t))+
'\n                    </div>\n                </div>\n            </div>\n        </li>\n        <li class="list-group-item text-right">\n            <a href="'+
((__t=( viewUrl || ('#view/' + payslip.id) ))==null?'':_.escape(__t))+
'" type="button"\n                class="btn btn-outline btn-success">\n                <i class="fa fa-eye"></i>\n                View\n            </a>\n            <a href="'+
((__t=( payslipPdf ? payslipPdf.downloadUrl() : '' ))==null?'':_.escape(__t))+
'"\n                target="_blank"\n                class="btn btn-outline btn-primary\n                    '+
((__t=( payslipPdf ? '' : 'disabled' ))==null?'':_.escape(__t))+
'">\n                <i class="fa fa-file-pdf-o"></i>\n                Download\n            </a>\n        </li>\n    </ul>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/commons/templates/PayslipCard.ejs
// module id = 803
// module chunks = 1